//
//
//
//
//
//
//
//
//
//

import RegisterForm from '~/components/form/user/auth/register-form'
import pageMeta, { mxGetMeta } from '~/mixins/pageMeta'
import guest from '~/middleware/guest'
import { asyncDataCatch, asyncDataStart } from '~/utils/asyncData'

export default {
  name: 'Register',
  components: { RegisterForm },
  mixins: [pageMeta],
  layout: 'auth',
  middleware: [guest],
  async asyncData (ctx) {
    await asyncDataStart(ctx)

    try{
      await mxGetMeta(ctx, {
        meta: {
          method: 'static'
        }
      })
    }catch (e){
      return asyncDataCatch(ctx, e)
    }
  },
  head () {
    return {
      ...this._mxMeta
    }
  }
}
